import type {
  Graph3DData,
  Graph3DPositionedEdge,
  Graph3DResolvedData,
} from '../core/graph.types';
import type { Graph3DLayoutConfig } from '../core/layout.types';
import { applyDagreLayout } from './applyDagreLayout';
import { applyLayeredLayout } from './applyLayeredLayout';
import { applyPresetLayout } from './applyPresetLayout';
import { calculateBounds } from './bounds';

export function resolveGraphLayout<TNodeData = unknown, TEdgeData = unknown>(
  data: Graph3DData<TNodeData, TEdgeData>,
  config: Graph3DLayoutConfig = {}
): Graph3DResolvedData<TNodeData, TEdgeData> {
  const positionedNodes =
    config.type === 'preset'
      ? applyPresetLayout(data, config)
      : config.type === 'dagre-like'
        ? applyDagreLayout(data, config)
        : applyLayeredLayout(data, config);
  const nodeMap = new Map(positionedNodes.map(node => [node.id, node]));
  const edges = data.edges.flatMap(edge => {
    const sourceNode = nodeMap.get(edge.source);
    const targetNode = nodeMap.get(edge.target);
    if (!sourceNode || !targetNode) {
      return [];
    }
    return [
      { ...edge, sourceNode, targetNode } as Graph3DPositionedEdge<
        TEdgeData,
        TNodeData
      >,
    ];
  });
  return {
    nodes: positionedNodes,
    edges,
    bounds: calculateBounds(positionedNodes),
  };
}
